import { memo } from 'react';

import DraftRegulation from './Regulation.tsx';

export const DraftRegulationContainer = () => {
  return <DraftRegulation />;
};

export default memo(DraftRegulationContainer);
